import React from 'react';
import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

const InstagramIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
    className={makeClassName('InstagramIcon', className)}
  >
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" fill="none" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" fill="none" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" fill="none" />
  </svg>
);

export default InstagramIcon;
